import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  costFormater,
  ErrorMessage,
  PriceInput,
  Text,
  useResponsive,
} from '@common-fe/common-fe';

interface Props {
  value: string;
  maxValue: number;
  errorText?: string;
  isSubmitted?: boolean;
  onSetValue: (value: string) => void;
}

const SelfDirectedInvestAmount: React.FC<Props> = ({
  value,
  onSetValue,
  maxValue,
  errorText,
  isSubmitted,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [key, setKey] = useState(0);

  const handleSetDefaultValue = useCallback(() => {
    onSetValue(`${maxValue || ''}`);
    setKey(key + 1);
  }, [key, maxValue, onSetValue]);
  return (
    <Box direction="column">
      <Box
        pad={isMobile ? 'spacing16' : 'spacing24'}
        background="canvas"
        round="container1Round"
        border={{ size: 'small', color: 'border2' }}
      >
        <Text size={isMobile ? 'large' : 'xxlarge'}>{t('How much would you like to invest?')}</Text>
        <Box direction="row" align="center" margin={{ top: 'spacing16' }}>
          <Box key={key} width={isMobile ? 'auto' : 'control'}>
            <PriceInput
              autoFocus
              isClearMode
              testId="invest-amount"
              errorStyle={{ flex: 'auto' }}
              errorText={isSubmitted && !isMobile ? errorText : ''}
              className="invest-amount-input"
              name="amount"
              placeholder="Enter $ amount"
              value={value}
              onChange={onSetValue}
            />
          </Box>
          <Box margin={{ left: 'spacing16' }}>
            <AppButton
              testId="invest-amount_set-max"
              buttonType="quaternary"
              onClick={handleSetDefaultValue}
              style={{ maxWidth: isMobile ? '160px' : '180px' }}
            >
              <Text truncate>
                Max.{' '}
                {costFormater(maxValue, {
                  isPrecision: true,
                })}
              </Text>
            </AppButton>
          </Box>
        </Box>
      </Box>
      {isSubmitted && isMobile && errorText && (
        <Box margin={{ top: 'spacing8', left: 'spacing16' }}>
          <ErrorMessage errorText={errorText} />
        </Box>
      )}
    </Box>
  );
};

export default SelfDirectedInvestAmount;
